<template>
    <NavBar></NavBar>
    <div class="container">
      <div class="row">
        <div class="col-md-6 title-container">
          <h1 class="title">Globes That Maybe Were</h1>
        </div>
        <div class="col-md-5">
          <!--<img class="cover-img" src="../assets/cover_globe.png">-->
          <p class="desc"><i>Globes That Maybe Were</i> is a digital exhibition of globe patent illustrations from 1840-1940. While the collection is not a complete record of globe patents from this period, it showcases the weird, wonderful, and downright impossible creations of overlooked cartographic innovators. The globes in these patent drawings may not have been constructed, may not have survived the test of time, but they remain alive in the patent archives. </p>
          <router-link class="grid-link" to="/globes">
              <button class="globe-button">
                  Go To Globes
              </button>
          </router-link>
        </div>
      </div>
    </div>
</template>
  
<script>
  import NavBar from "../components/NavBar.vue"

  export default {
    name: 'HomePage',
    components: {
        NavBar
    }
  }
</script>

<style scoped>
.title-container{
  background-image:url("../assets/cover_globe.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  height:100vh;
}
  .title{
    text-transform: uppercase;
    text-align:right;
    font-weight:bold;
    font-family: Franklin;
    font-size:7em;
  }
  .desc{
    font-size:24px;
    margin-top:25px;
  }
  
</style>
  